import { Deck } from './Deck';

export class DeckItemGroup {

	public title: string = '';
	public list: Deck[] = [];

	constructor(init?: Partial<DeckItemGroup>) {
		Object.assign(this, init);
	}

}
